import React from 'react';

import { formatMoney, toMoney } from '@betterment/core';
import { Text } from '@betterment/samba-react';

import { ModalSectionRow } from '../../../../Shared/components-v2/modal-section/ModalSectionRow';
import { PurposeSettingsQuery } from '../graphql/purposeSettings.generated';

type Props = {
  target: Extract<PurposeSettingsQuery['purpose']['target'], { __typename: 'TargetMonthlyExpenses' }>;
};
type RowTuple = [string, string | number];

export const TargetMonthlyExpenses: React.FC<React.PropsWithChildren<Props>> = ({ target }) => {
  const savingsTarget = target.amount ? formatMoney(toMoney(target.amount.cents)) : 'Not set';
  const estimatedMonthlyExpenses = formatMoney(toMoney(target.monthlyExpensesAmount.cents));

  const emergencyFundTuples: RowTuple[] = [
    ['Savings target', savingsTarget],
    ['Estimated Monthly Expenses', estimatedMonthlyExpenses],
  ];

  return (
    <>
      {emergencyFundTuples.map(tuple => (
        <ModalSectionRow key={tuple[0]}>
          <ModalSectionRow.LeadingContent>
            <Text>{tuple[0]}</Text>
          </ModalSectionRow.LeadingContent>
          <ModalSectionRow.TrailingContent>
            <Text>{tuple[1]}</Text>
          </ModalSectionRow.TrailingContent>
        </ModalSectionRow>
      ))}
    </>
  );
};
